var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.33203,
    y: 4.33325,
    width: 33.3333,
    height: 33.3333,
    rx: 16.6667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 2.33325C23.5648 2.33329 26.0021 2.82215 28.291 3.80981C30.5411 4.78074 32.5181 6.10823 34.2041 7.79419C35.8901 9.48022 37.2185 11.4572 38.1895 13.7073C39.1772 15.9963 39.665 18.4344 39.665 21.0002C39.665 23.5659 39.1771 26.0034 38.1895 28.2922C37.2185 30.5424 35.8902 32.5193 34.2041 34.2053C32.518 35.8914 30.5412 37.2197 28.291 38.1907C26.0022 39.1783 23.5647 39.6662 20.999 39.6663C18.4332 39.6663 15.995 39.1784 13.7061 38.1907C11.4559 37.2197 9.479 35.8914 7.79297 34.2053C6.10701 32.5193 4.77952 30.5423 3.80859 28.2922C2.82092 26.0034 2.33207 23.566 2.33203 21.0002C2.33203 18.4344 2.82088 15.9963 3.80859 13.7073C4.77954 11.4573 6.107 9.48016 7.79297 7.79419C9.47894 6.10822 11.456 4.78076 13.7061 3.80981C15.995 2.8221 18.4332 2.33325 20.999 2.33325Z",
    fill: "#C1E521",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickLight);
export default __webpack_public_path__ + "static/media/tick-light.d80aabc61e35a45bdcd36a7169332460.svg";
export { ForwardRef as ReactComponent };